"use strict";

document.addEventListener("DOMContentLoaded", () => {
    const recentlyViewed = {

        productHandle: null,
        rvCookie: null,
        rvProductArray: [],
        displayProducts: [],

        /*
         * Initialize
         */
        init: function () {

            const productSection = document.querySelector(
                ".js-product_section[data-rv-handle]"
            );

            const recentlyViewedSections = document.querySelectorAll(
                ".recently-viewed__section"
            );

            /*
             * Nothing related to Recently Viewed on this page.
             * Stop immediately.
             */
            if (!productSection && recentlyViewedSections.length === 0) {
                return;
            }

            /*
             * Get current product handle
             */
            if (productSection) {
                this.productHandle = productSection.dataset.rvHandle || "";
            }

            /*
             * Get cookie
             */
            this.rvCookie = this.getCookie("recentlyViewed");

            /*
             * Convert cookie into array
             */
            if (this.rvCookie) {
                try {
                    this.rvProductArray = decodeURIComponent(this.rvCookie)
                        .split(",")
                        .filter(Boolean);
                } catch (error) {
                    this.rvProductArray = [];
                }
            }

            /*
             * Add current product if it isn't already in the list
             */
            if (
                this.productHandle &&
                this.rvProductArray.indexOf(this.productHandle) === -1
            ) {
                this.rvProductArray.unshift(this.productHandle);
            }

            /*
             * Remove duplicates
             */
            this.rvProductArray = [...new Set(this.rvProductArray)];

            /*
             * Keep cookie small.
             *
             * We only need a limited number of recently viewed products.
             */
            this.rvProductArray = this.rvProductArray.slice(0, 20);

            /*
             * Save updated list
             */
            if (this.productHandle) {
                this.setCookieProducts(this.rvProductArray);
            }

            /*
             * Products to display
             */
            this.displayProducts = [...this.rvProductArray];

            /*
             * Load Recently Viewed sections
             */
            recentlyViewedSections.forEach((section) => {

                const rvMain = section.querySelector(".rv-main");

                if (!rvMain) {
                    return;
                }

                this.getProductInformation(
                    section,
                    this.displayProducts,
                    this.productHandle
                );
            });
        },

        /*
         * Display Recently Viewed Products
         */
        getProductInformation: function (
            parent,
            displayProducts,
            productHandle
        ) {

            let products = displayProducts;

            const productLimit = parseInt(
                parent.dataset.visibleProducts,
                10
            );

            if (productLimit > 0) {
                products = products.slice(0, productLimit);
            }

            if (!products.length) {
                return;
            }

            /*
             * Fetch all products concurrently.
             */
            const requests = products.map((product, index) => {

                if (!product) {
                    return Promise.resolve();
                }

                return fetch(
                    `/products/${encodeURIComponent(product)}?view=rv`
                )
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(
                                `Recently viewed request failed: ${response.status}`
                            );
                        }

                        return response.text();
                    })
                    .then((html) => {

                        const parser = new DOMParser();

                        const data = parser.parseFromString(
                            html,
                            "text/html"
                        );

                        const rvProductHTML = data.querySelector(
                            ".js-recently-viewed-product"
                        );

                        if (!rvProductHTML) {
                            return;
                        }

                        const targetElement = parent.querySelector(
                            `.rv-box-${index}`
                        );

                        if (!targetElement) {
                            return;
                        }

                        targetElement.innerHTML =
                            rvProductHTML.innerHTML;

                        /*
                         * Reveal section only after actual content exists.
                         */
                        parent.classList.remove("hidden");
                    })
                    .catch(() => {
                        /*
                         * Silently ignore individual failed products.
                         */
                    });
            });

            /*
             * Once all product requests finish,
             * clean empty boxes and refresh slider.
             */
            Promise.all(requests).then(() => {

                parent.querySelectorAll(".grid__item").forEach((gridItem) => {

                    if (!gridItem.innerHTML.trim()) {
                        gridItem.remove();
                    }

                });

                /*
                 * Refresh Swiper if available.
                 */
                const swiperElement = parent.querySelector(".swiper");

                if (
                    swiperElement &&
                    swiperElement.swiper &&
                    typeof swiperElement.swiper.update === "function"
                ) {
                    swiperElement.swiper.update();
                }

                /*
                 * Refresh Recently Viewed pagination if available.
                 */
                const viewerElement = parent.querySelector(
                    '[id^="RecentlyViewer"]'
                );

                if (
                    viewerElement &&
                    typeof viewerElement.resetPages === "function"
                ) {
                    viewerElement.resetPages();
                }
            });
        },

        /*
         * Get cookie
         */
        getCookie: function (name) {

            const matches = document.cookie.match(
                new RegExp(
                    "(?:^|; )" +
                    name.replace(
                        /([\.$?*|{}\(\)\[\]\\\/\+^])/g,
                        "\\$1"
                    ) +
                    "=([^;]*)"
                )
            );

            return matches
                ? matches[1]
                : undefined;
        },

        /*
         * Set Recently Viewed cookie
         */
        setCookieProducts: function (products) {

            this.setCookie(
                "recentlyViewed",
                products.join(","),
                {
                    expires: 30,
                    path: "/",
                    sameSite: "None",
                    secure: true
                }
            );
        },

        /*
         * Generic cookie setter
         */
        setCookie: function (name, value, options) {

            options = options || {};

            options.path = options.hasOwnProperty("path")
                ? options.path
                : "/";

            if (
                typeof options.expires === "number" &&
                options.expires
            ) {
                const date = new Date();

                date.setDate(
                    date.getDate() + options.expires
                );

                options.expires = date.toUTCString();
            }

            value = encodeURIComponent(value);

            let updatedCookie = name + "=" + value;

            for (const propName in options) {

                updatedCookie += "; " + propName;

                const propValue = options[propName];

                if (propValue !== true) {
                    updatedCookie += "=" + propValue;
                }
            }

            document.cookie = updatedCookie;
        }
    };

    /*
     * Initialize Recently Viewed
     */
    recentlyViewed.init();

    /*
     * Shopify Theme Editor
     */
    if (Shopify.designMode) {

        document.addEventListener(
            "shopify:section:load",
            () => {
                recentlyViewed.init();
            }
        );
    }
});